export default "__VITE_ASSET__DeyHDOYW__"